<template>
  <div>
    <n-loading-spinner v-if="isLoading"></n-loading-spinner>
    <component
      v-show="!isLoading"
      v-bind:is="getComponentName()"
      v-on:configSaved="configSaved"
      v-on:loaded="loaded()"
    ></component>
  </div>
</template>

<script lang="ts" setup>
import btsmsConfig from '../../btsms/btsmsConfig.vue';
import govuknotifysmsConfig from '../../govuknotifysms/govuknotifysmsConfig.vue';
import messengerConfig from '../../messenger/messengerConfig.vue';
import whatsappConfig from '../../messenger/whatsappConfig.vue';
import Toast from '@/shared/services/toast';
import { GET_CHANNEL_IDENTITIES } from '@/store/channel-identities/actionTypes';
import { ChannelIdentityViewModel } from '@/messaging/models/channelIdentityViewModel';
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';
import { computed, ref } from 'vue';

const configComponents = {
  btsmsConfig,
  govuknotifysmsConfig,
  messengerConfig,
  whatsappConfig,
};

const router = useRouter();
const store = useStore();
const currentApp = computed(() => store.getters.currentApp);
const loadChannelIdentities = (forceReload = false): Promise<ChannelIdentityViewModel[]> =>
  store.dispatch(GET_CHANNEL_IDENTITIES, forceReload);

const isLoading = ref(true);

function getComponentName() {
  if (currentApp.value.id === 'instagram') {
    return configComponents.messengerConfig;
  }

  const componentKey = `${currentApp.value.id.replaceAll('-', '')}Config` as keyof typeof configComponents;
  return configComponents[componentKey];
}

async function configSaved(stopRedirect: boolean) {
  await loadChannelIdentities(true);
  if (!stopRedirect) {
    // go back to appstore
    await router.push({ name: 'apps' });
  }
  Toast.showSuccess('App setup completed');
}

function loaded() {
  isLoading.value = false;
}
</script>
